module.exports = __webpack_public_path__ + "2f978f0b20dff5cd2d12116b1afaabba.jpg";